module.exports = __webpack_public_path__ + "static/assets/0c3bf4f8d7f09bc419187068b1145a24.svg";